// Defensive patch for the well-known DOMException "NotFoundError: The object
// can not be found here." ("El objeto no se encuentra aquí.") crash.
// It happens when DOM-mutating tools (Google Translate in the browser, some
// extensions) move text nodes and React then tries to removeChild/insertBefore
// on a node that is no longer a child. We make these operations no-throw.
export function installDomSafetyPatch() {
  if (typeof Node !== "function" || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      if (child.parentNode) {
        return child.parentNode.removeChild(child);
      }
      return child;
    }
    // eslint-disable-next-line prefer-rest-params
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return this.appendChild(newNode);
    }
    // eslint-disable-next-line prefer-rest-params
    return originalInsertBefore.apply(this, arguments);
  };
}
